import Service from "../../services";

const state = {
  checkBtn: true,
  allPortfolio: [],
  portfolioDetail: {
    profile_id: null,
    category_id: null,
    subcategory_id: null,
    project_title: null,
    project_brief: null,
    detail: null,
    cover_img_path: null,
    cover_img_share_path: null,
    moreImages: [
      // pattern
      // {
      //     id: 1,
      //     image: null,
      //     description: ""
      // }
    ],
  },
  category: [],
  subCategory: [],
  portfolio_articles: [],
  activeMainMenu: null,
  portfolio_categorys: {
    portfolios: {},
    subCategoryLists: null,
    category_id: 0,
    subcategory_id: null,
    paginate: {
      current_page: 1,
      last_page: 1,
    },
  },
  portfolio_design: {
    portfolios: [],
    subCategoryLists: null,
    profile_id: "",
    categoryID: 0,
    subcategory_id: null,
    paginate: {
      current_page: 1,
      last_page: 1,
    },
  },
  portfolio_tags: [],
  portfolio_search: [],
  count_item: null,
};

const getters = {};

const actions = {
  onGetAllPortfolioByMemberId({ commit }, id) {
    return Service.portfolio.getAllPortfolioByMemberId(id).then((res) => {
      if (res.status === 200) {
        commit("setAllPortfolio", res.data);
      }
    });
  },

  onGetPortfolio({ commit }, id) {
    return Service.portfolio.getPortfolio(id).then((res) => {
      // if (res.status === 200) {
      //     // commit('setPortfolioDetail', res.data);
      // }
      return res;
    });
  },

  onCreatePortfolio({ commit }, data) {
    return Service.portfolio.createPortfolio(data).then((res) => {
      if (res.status === 200) {
        // this.$swal({
        //     icon: 'success',
        //     title: 'Create Portfolio successfully!',
        //     confirmButtonColor: '#FD5246',
        //     confirmButtonText: 'ตกลง',
        // });
        alert("Create Portfolio successfully!");
        return res;
      }
    });
  },

  onEditPortfolio({ commit }, data) {
    return Service.portfolio.editPortfolio(data).then((res) => {
      if (res.status === 200) {
        // this.$swal({
        //     icon: 'success',
        //     title: 'Edit Portfolio successfully!',
        //     confirmButtonColor: '#FD5246',
        //     confirmButtonText: 'ตกลง',
        // });
        alert("Edit Portfolio successfully!");
        return res;
      }
    });
  },

  onDeletePortfolio({ commit }, id) {
    return Service.portfolio.deletePortfolio(id).then((res) => {
      return res;
    });
  },

  onUploadPortfolioImage({ commit }, data) {
    let param = new FormData();
    param.append("file", data.image);
    param.append("type", data.type);
    return Service.image
      .uploadImage(param)
      .then((res) => {
        if (res.status === 200) {
          if (data.type === "portfolio-cover") {
            commit("setCoverImage", res.data);
          } else if (data.type === "portfolio-images") {
            let dataWithId = { id: data.id, name: res.data };
            commit("setMoreImages", dataWithId);
          } else if (data.type === "portfolio-cover-share") {
            commit("setCoverShareImage", res.data);
          }
        }
        return res;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },

  onGetCategory({ commit }) {
    return Service.portfolio.getCategory().then((res) => {
      // if (res.status === 200) {
      //     commit("setCategory", res.data);
      // }
      return res;
    });
  },

  onGetCategoryList({ commit }) {
    return Service.portfolio.onGetCategoryList().then((res) => {
      return res;
    });
  },

  onGetSubCategory({ commit }) {
    return Service.portfolio.getSubCategory().then((res) => {
      // if (res.status === 200) {
      //     commit("setSubCategory", res.data);
      // }
      return res;
    });
  },

  getPortfolioDetailByMemberId({ commit }, id) {
    return Service.portfolio
      .getPortfolio(id)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
  previewPortfolioDetailByMemberId({ commit }, id) {
    return Service.portfolio
      .previewPortfolioDetailByMemberId(id)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },

  getMostViewPortfolio({ commit }) {
    return Service.portfolio
      .getMostViewPortfolio()
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },

  getNewPortfolio({ commit }) {
    return Service.portfolio
      .getNewPortfolio()
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },

  getPortfolioByIdCategory({ commit }, val) {
    return Service.portfolio
      .getPortfolioByIdCategory(val)
      .then((res) => {
        let cate_id = "";
        switch (val.id) {
          case "new":
            cate_id = 0;
            break;
          case "most":
            cate_id = 0;
            break;
          default:
            cate_id = val.id;
            break;
        }
        let data = {
          data: res.data,
          category_id: cate_id,
          subcategory_id: 0,
        };
        commit("SET_PORTFOLIO_CATEGORY", data);
        return res.data;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },

  getPortfolioByIdCategoryMore({ commit, state }, val) {
    return Service.portfolio
      .getPortfolioByIdCategory(val)
      .then((res) => {
        let resPortfolios = res.data.portfolios;
        // merge ข้อมมูลเก่ากับข้อมูลใหม่
        resPortfolios.data = [
          ...state.portfolio_categorys.portfolios.data,
          ...res.data.portfolios.data,
        ];
        let data = {
          data: res.data,
          category_id: val.id,
          portfolios: resPortfolios,
          subcategory_id: 0,
        };
        commit("SET_PORTFOLIO_CATEGORY_MORE", data);
        return res.data;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },

  getPortfolioByIdTag({ commit }, data) {
    return Service.portfolio
      .getPortfolioByIdTag(data)
      .then((res) => {
        commit("SET_PORTFOLIO_TAG", res);
        return res;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },

  getPortfolioBySearch({ commit }, data) {
    return Service.portfolio
      .getPortfolioBySearch(data)
      .then((res) => {
        commit("SET_PORTFOLIO_SEARCH", res);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },

  getPortfolioByIdSubCategory({ commit }, val) {
    return Service.portfolio
      .getPortfolioByIdSubCategory(val)
      .then((res) => {
        let data = {
          data: res.data,
          category_id: val.category_id,
          subcategory_id: val.subcategory_id,
        };
        commit("SET_PORTFOLIO_SUBCATEGORY", data);
        return res;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },

  getPortfolioByIdSubCategoryMore({ commit, state }, val) {
    return Service.portfolio
      .getPortfolioByIdSubCategory(val)
      .then((res) => {
        let resPortfolios = res.data.portfolios;
        // merge ข้อมมูลเก่ากับข้อมูลใหม่
        resPortfolios.data = [
          ...state.portfolio_categorys.portfolios.data,
          ...res.data.portfolios.data,
        ];
        let data = {
          data: res.data,
          category_id: val.category_id,
          portfolios: resPortfolios,
          subcategory_id: val.subcategory_id,
        };
        commit("SET_PORTFOLIO_SUBCATEGORY_MORE", data);
        return res.data;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },

  getPortfolioDesign({ commit }, data) {
    return Service.portfolio
      .getPortfolioDesign(data)
      .then((res) => {
        let obj_res = {
          portfolios: res.data.portfolios,
          subCategoryLists: res.data.subCategorys,
          category_id: data.category_id,
          subcategory_id: data.subcategory_id,
        };
        commit("SET_PORTFOLIO_DESIGN", obj_res);
        return res;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },

  saveView({ commit }, id) {
    return Service.portfolio.saveView(id).then((res) => {
      return res;
    });
  },

  getTopRank({ commit }, data) {
    return Service.portfolio.getTopRank(data).then((res) => {
      return res;
    });
  },

  getSortTopRank({ commit }, data) {
    return Service.portfolio.getSortTopRank(data).then((res) => {
      return res;
    });
  },

  getToprankHomepage({ commit }, data) {
    return Service.portfolio.getToprankHomepage(data).then((res) => {
      return res;
    });
  },

  shareFacebook({ commit }, id) {
    return Service.portfolio.shareFacebook(id).then((res) => {
      return res;
    });
  },

  clearActiveMenuCate({ commit }, val) {
    commit("CLEAR_ACTIVE_MENU_CATE", val);
  },

  getMostDesignPortfolio({ commit }) {
    return Service.portfolio.getMostDesignPortfolio().then((res) => res);
  },

  getProfilePortfolio({ commit }, data) {
    return Service.portfolio.getProfilePortfolio(data).then((res) => res);
  },

  getOrtherPortfolios({ commit }, data) {
    return Service.portfolio.getOrtherPortfolios(data).then((res) => res);
  },

  clearPaginate({ commit }) {
    commit("CLEAR_PAGINATE");
  },
};

const mutations = {
  setAllPortfolio(state, data) {
    state.allPortfolio = data;
  },
  clearAllPortfolio(state, data) {
    state.allPortfolio = [];
  },

  resetPortfolioDetail(state) {
    state.portfolioDetail = {
      profile_id: null,
      category_id: null,
      subcategory_id: null,
      project_title: null,
      project_brief: null,
      detail: null,
      cover_img_path: null,
      cover_img_share_path: null,
      moreImages: [],
    };
  },

  addAnImage(state) {
    if (state.portfolioDetail.moreImages.length <= 0) {
      state.portfolioDetail.moreImages.push({
        id: 1,
        image: null,
        description: "",
      });
    } else {
      let lastId =
        state.portfolioDetail.moreImages[
          state.portfolioDetail.moreImages.length - 1
        ].id;
      state.portfolioDetail.moreImages.push({
        id: lastId + 1,
        image: null,
        description: "",
      });
    }
  },
  removeAnImage(state, id) {
    state.portfolioDetail.moreImages = state.portfolioDetail.moreImages.filter(
      (item) => {
        if (item.id !== id) {
          return item;
        }
      }
    );
  },

  setCoverImage(state, data) {
    if (data === null) {
      document.getElementById("portfolio_cover").value = "";
    }
    state.portfolioDetail.cover_img_path = data;
  },

  setCoverShareImage(state, data) {
    if (data === null) {
      document.getElementById("portfolio_cover_share").value = "";
    }
    state.portfolioDetail.cover_img_share_path = data;
  },

  setMoreImages(state, data) {
    state.portfolioDetail.moreImages.forEach((item) => {
      if (item.id === data.id) {
        item.image = data.name;
      }
    });
  },

  setCategory(state, data) {
    state.category = data;
  },

  setSubCategory(state, data) {
    state.subCategory = data;
  },

  SET_PORTFOLIO(state, data) {
    state.portfolio_articles = data.data.data.portfolios;
    state.categorys.sub_category_list = data.data.data.subCategorys;
    state.categorys.category_id = data.category_id;
    state.categorys.subCategory_id = data.subCategory_id;
  },

  SET_PORTFOLIO_CATEGORY(state, data) {
    state.checkBtn = true;
    state.portfolio_categorys.portfolios = data.data.portfolios;
    if (data.data.subCategorys.length == 0) {
      state.portfolio_categorys.subCategoryLists = null;
    } else {
      data.data.subCategorys.sub_cate.sort(function(a, b) {
        return a.count_port - b.count_port;
      });
      state.portfolio_categorys.subCategoryLists = data.data.subCategorys.sub_cate.reverse();
    }
    state.portfolio_categorys.category_id = data.category_id;
    state.portfolio_categorys.subcategory_id = data.subcategory_id;
    // state.portfolio_categorys.paginate.current_page = data.data.portfolios.current_page;
    // state.portfolio_categorys.paginate.last_page = data.data.portfolios.last_page;
    state.count_item = data.data.count_item;
  },

  SET_PORTFOLIO_CATEGORY_MORE(state, data) {
    state.checkBtn = true;
    state.portfolio_categorys.portfolios = data.portfolios;
    // state.portfolio_categorys.subCategoryLists = data.data.subCategorys;
    data.data.subCategorys.sub_cate.sort(function(a, b) {
      return a.count_port - b.count_port;
    });
    state.portfolio_categorys.subCategoryLists = data.data.subCategorys.sub_cate.reverse();
    state.portfolio_categorys.category_id = data.category_id;
    state.portfolio_categorys.subcategory_id = data.subcategory_id;
    state.count_item = data.data.count_item;
  },

  SET_PORTFOLIO_SUBCATEGORY(state, data) {
    state.checkBtn = false;
    state.portfolio_categorys.portfolios = data.data.portfolios;
    data.data.subCategorys.sub_cate.sort(function(a, b) {
      return a.count_port - b.count_port;
    });
    state.portfolio_categorys.subCategoryLists = data.data.subCategorys.sub_cate.reverse();
    state.portfolio_categorys.category_id = data.category_id;
    state.portfolio_categorys.subcategory_id = data.subcategory_id;
    state.count_item = data.data.count_item;
    // state.portfolio_categorys.paginate.current_page = data.data.portfolios.current_page;
    // state.portfolio_categorys.paginate.last_page = data.data.portfolios.last_page;
  },

  SET_PORTFOLIO_SUBCATEGORY_MORE(state, data) {
    state.checkBtn = false;
    state.portfolio_categorys.portfolios = data.portfolios;
    // state.portfolio_categorys.subCategoryLists = data.data.subCategorys;
    data.data.subCategorys.sub_cate.sort(function(a, b) {
      return a.count_port - b.count_port;
    });
    state.portfolio_categorys.subCategoryLists = data.data.subCategorys.sub_cate.reverse();
    state.portfolio_categorys.category_id = data.category_id;
    state.portfolio_categorys.subcategory_id = data.subcategory_id;
    state.count_item = data.data.count_item;
  },

  CLEAR_ACTIVE_MENU_CATE(state, val) {
    state.activeMainMenu = val;
    state.portfolio_categorys.category_id = null;
    state.portfolio_design.categoryID = 0;
  },

  SET_PORTFOLIO_DESIGN(state, data) {
    state.portfolio_design.portfolios = data.portfolios;
    state.portfolio_design.subCategoryLists = data.subCategoryLists;
    state.portfolio_design.categoryID = data.category_id;
    state.portfolio_design.subcategory_id = data.subcategory_id;
    state.portfolio_design.paginate.current_page = data.portfolios.current_page;
    state.portfolio_design.paginate.last_page = data.portfolios.last_page;
  },

  SET_PORTFOLIO_TAG(state, data) {
    state.portfolio_tags = data.data;
  },
  SET_PORTFOLIO_SEARCH(state, data) {
    state.portfolio_search = data.data;
  },

  CLEAR_PAGINATE(state) {
    state.portfolio_design.portfolios = [];
    state.portfolio_design.subCategoryLists = [];
    state.portfolio_design.profile_id = "";
    state.portfolio_design.categoryID = 0;
    state.portfolio_design.subcategory_id = null;
    state.portfolio_design.paginate.current_page = 1;
    state.portfolio_design.paginate.last_page = 1;
  },

  CLEAR_PORTFOLIO(state) {
    state.allPortfolio = [];
    state.portfolioDetail = {
      profile_id: null,
      category_id: null,
      subcategory_id: null,
      project_title: null,
      project_brief: null,
      detail: null,
      cover_img_path: null,
      cover_img_share_path: null,
      moreImages: [],
    };
    state.category = [];
    state.subCategory = [];
    state.portfolio_articles = [];
    state.activeMainMenu = null;
    state.portfolio_categorys = {
      portfolios: {},
      subCategoryLists: [],
      category_id: 0,
      subcategory_id: null,
      paginate: {
        current_page: 1,
        last_page: 1,
      },
    };
    state.portfolio_design = {
      portfolios: [],
      subCategoryLists: [],
      profile_id: "",
      categoryID: 0,
      subcategory_id: null,
      paginate: {
        current_page: 1,
        last_page: 1,
      },
    };
    state.portfolio_tags = [];
    state.portfolio_search = [];
    state.count_item = null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
